export default __webpack_public_path__ + "static/media/LinkedInColor.505c6255.svg";